import Modal from 'react-modal';

import CloseOutlined from '@ant-design/icons/CloseOutlined';

import FilePreview from 'components/ProductSide/FilePreview';
import Box from 'components/Box/Box';
import ToolsBar from 'components/Tools/ToolsBar';

import { imagePlaces, scalingMethods } from 'utils/constants';

import { ISide } from 'types/types';
import SContainer from 'components/Container/Container';

Modal.setAppElement('#root');

const customStyles = {
  content: {
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    padding: 0,
    border: 'none',
  },
};

type Props = {
  originalPdfFile: Blob;
  pdfFile: Blob | undefined;
  width: number;
  height: number;
  actions: ISide['actions'];
  isOpen: boolean;
  onFlip: () => void;
  onRotate: (direction: 'left' | 'right') => void;
  onChangePlace: (place: string) => void;
  onChangeType: (type: string) => void;
  onClose: () => void;
};

function Editor({
  pdfFile,
  originalPdfFile,
  actions,
  onFlip,
  onRotate,
  onChangePlace,
  onChangeType,
  isOpen,
  onClose,
}: Props) {
  return (
    <>
      <Modal
        isOpen={isOpen}
        onRequestClose={onClose}
        style={customStyles}
        contentLabel="File Editor"
      >
        <SContainer>
          <Box flexGrow={1} display="flex" justifyContent="center" alignItems="center">
            <FilePreview
              file={pdfFile || originalPdfFile}
              small={false}
              loading={false}
              onClick={() => {}}
            />
          </Box>
          <Box textAlign="left" p={3} pb={9} width={300} minWidth={300} background="#ffffff">
            <Box textAlign="right">
              <CloseOutlined style={{ cursor: 'pointer' }} onClick={onClose} />
            </Box>
            <ToolsBar
              place={actions.place}
              type={actions.type}
              imagePlaces={imagePlaces}
              scalingMethods={scalingMethods}
              onChangePlace={onChangePlace}
              onRotateRight={() => onRotate('right')}
              onRotateLeft={() => onRotate('left')}
              onFlip={onFlip}
              onChangeType={onChangeType}
              // onDownload={() => FileSaver.saveAs(new Blob([pdfFile]), 'result.pdf')}
            />
          </Box>
        </SContainer>
      </Modal>
    </>
  );
}

export default Editor;
